module.exports = __webpack_public_path__ + "img/fruit-papaya-350x184.0fdd5ff8.jpg";